<template>
    <section class="main-view">
        <div class="container-scroller">
            <Header :is-special-route="isSpecialRoute" @nav-visibility="onNavVisibility" @user-logout="onUserLogout" />
                <div class="container-fluid page-body-wrapper"
                    :class="[
                        'client-dashbboard',
                        {
                            Homescreen: isHomePage,
                            LoggedIn: showAfterLogin,
                            'english-header': selectedLanguage === 'en',
                            'has-bookings': navShowBooking === true,
                            'no-bookings': navShowBooking === false,
                            'has-manage-dashboard': navShowManage === true,
                            'no-manage-dashboard': navShowManage === false
                        }
                    ]"
                >
                <div class="main-panel">
                    <div class="content-wrapper">
                        <router-view></router-view>
                        <!-- <div class="load-content" v-if="isLoading">
                            <vue-loaders-ball-clip-rotate color="#70D3FF" scale="2.1"></vue-loaders-ball-clip-rotate>
                        </div>
                        <div v-else>
                            <router-view></router-view>
                        </div> -->
                    </div>
                    <!-- content wrapper ends -->
                    <Footer/>
                </div>
                <!-- main panel ends -->
            </div>
            <!-- page-body-wrapper ends -->
        </div>
    </section>
</template>

<script>
import Header from "./partials/Header";
import Footer from "./partials/Footer";
import Vue from 'vue';

export default {
    name: "guest_layout",
    components: {
        Header,
        Footer,
    }, 
    data() {
        return {
            getPermissionsData: [],
            isLoading: true,
            showAfterLogin: false,
            selectedLanguage: '',
            currentLanguage:''
            ,
            // nav visibility flags set by Header via event
            navShowBooking: null,
            navShowManage: null
        };
    }, 
    computed: {
        isSpecialRoute() {
            return this.$route.name === "property_detail"; 
        },
        isHomePage() {
            return this.$route.name === "home"; // Adjust if your home route uses a different name
        }
    },
    beforeMount() {
        this.getPermissions();
    }, 
    mounted() { 
        this.Authorization = localStorage.getItem('isLoggedin');
        if (this.Authorization !== null) {
            this.showAfterLogin = true;
            this.showBeforeLogin = false;
        } else {
            this.showBeforeLogin = true;
        }
        Vue.prototype.$EventBus.$on('changeLanguage', this.onLanguageChanged);
        // restore selected language so header class reflects persisted choice on reload
        const persisted = localStorage.getItem('selectedLanguage');
        if (persisted) {
            this.selectedLanguage = persisted;
            this.currentLanguage = persisted === 'en' ? '' : `_${persisted}`;
        }
    }, 
    methods: {
        changeLanguage(language) {
            Vue.prototype.$EventBus.$emit('changeLanguage', language);
            this.selectedLanguage = language;
            try {
                localStorage.setItem('selectedLanguage', language);
            } catch (e) {
                console.warn('Unable to persist selectedLanguage to localStorage', e);
            }
        },
        onLanguageChanged(language) {
            // Keep both selectedLanguage and currentLanguage in sync
            this.selectedLanguage = language;
            this.currentLanguage = language === 'en' ? '' : `_${language}`;
            try {
                localStorage.setItem('selectedLanguage', language);
            } catch (e) {
                console.warn('Unable to persist selectedLanguage to localStorage', e);
            }
        },
        handleIsLoading(data) {
            this.isLoading = data;
        },
        onNavVisibility(payload) {
            // payload: { showBooking: boolean, showManage: boolean }
            if (payload && typeof payload === 'object') {
                this.navShowBooking = payload.showBooking ?? null;
                this.navShowManage = payload.showManage ?? null;
            }
        },
        onUserLogout() {
            // Header emitted logout — update layout state so LoggedIn class is removed immediately
            try { localStorage.removeItem('isLoggedin'); } catch (e) { console.warn(e); }
            this.showAfterLogin = false;
            this.navShowBooking = false;
            this.navShowManage = false;
        },
        logout() {
            // Clear login flag so mounted check and other components see logged-out state
            try {
                localStorage.removeItem('isLoggedin');
            } catch (e) {
                console.warn('Unable to remove isLoggedin from localStorage', e);
            }
            try {
                localStorage.removeItem('userPermissions');
            } catch (e) {
                console.warn('Unable to remove userPermissions from localStorage', e);
            }
            this.showAfterLogin = false;
            this.showBeforeLogin = true;
        },
        getPermissions() {
            // this.getPermissionsData = JSON.parse(this.$session.get('userPermissions'));
            this.getPermissionsData = JSON.parse(localStorage.getItem('userPermissions'));
        },
        permissionExist(param) {
            var check = this.getPermissionsData.includes(param);
            if (check) {
                return true;
            } else {
                return false;
            }
        }
    },
    beforeDestroy() {
        Vue.prototype.$EventBus.$off('changeLanguage', this.onLanguageChanged);
    },
};
</script>
